import { Box } from '@mui/material';
import { SxProps, Theme } from '@mui/material/styles';
import LockIcon from '~/components/SVG/Lock.svg?react';

const styles: { icon: SxProps<Theme> } = {
  icon: (theme: Theme) => ({
    width: '60px',
    height: '60px',
    [theme.breakpoints.down('sm')]: {
      width: '40px',
      height: '40px',
    },
  }),
};

const Lock = () => {
  return <Box component={LockIcon} sx={styles.icon} />;
};

export default Lock;
